<template>
  <!-- Slider -->
  <div class="grid grid-cols-1">
    <Slider />
  </div>

  <section class="p-10 pb-10 2xl:px-96">
    <!-- Main Grid -->
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div class="bg-gray-100 py-3 px-5 rounded-md text-green-600 h-80">
        <ul>
          <li
            v-for="laporan in laporans"
            :key="laporan"
            @click="displayPDF(laporan.file_pdf)"
            class="py-1 font-semibold border-b uppercase"
          >
            <a href="#TentangBaznas">{{ laporan.judul }}</a>
          </li>
        </ul>
      </div>
      <div class="col-span-2 w-full" style="height: 1000px">
        <iframe height="100%" width="100%" :src="file_pdf"></iframe>
      </div>
    </div>
  </section>

  <WhatsappButton />
</template>

<script>
//hook vue
import { computed, onMounted } from "vue";

//vuex
import { useStore } from "vuex";

//component slider
import Slider from "@/components/Slider.vue";

// component WhatsappButton
import WhatsappButton from "@/components/WhatsappButton.vue";

export default {
  data: function () {
    return {
      file_pdf: "",
    };
  },

  components: {
    Slider, // <-- register component slider
    WhatsappButton,
  },

  methods: {
    displayPDF: function (data) {
      this.file_pdf = data;
    },
  },

  setup() {
    //store vuex
    const store = useStore();

    //onMounted akan menjalankan action "getCampaign" di module "campaign"
    onMounted(() => {
      store.dispatch("laporan/getLaporan");
    });

    // Storing Data
    const laporans = computed(() => {
      return store.state.laporan.laporans;
    });

    return {
      laporans,
    };
  },
};
</script>
